import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faHeart } from "@fortawesome/free-regular-svg-icons"

export const HeartRegular = (props) => {
  return <FontAwesomeIcon faIcon={faHeart} {...props} />
}
